<div class="avatar-container banner" (click)="editable && fileInputBanner.click()">
  <input class="hidden" #fileInputBanner type="file" accept="image/*" (change)="onBannerImageSelected($event)">
  @if (editable) {
    <div class="icon-container" matTooltip="Upload banner">
      <mat-icon>photo_camera</mat-icon>
    </div>
  }
  <div class="banner">
    <lib-photo [url]="banner?.photoUrl" [width]="'195px'" [height]="'130px'" [radius]="'10px'"></lib-photo>
  </div>
  @if (!banner?.photoUrl && !banner?.uploadKey) {
    <div class="image-info">Banner 3:2</div>
  }
</div>